__turbopack_context__.v({
  "blok-big-title": "TagBlok-module__cl093W__blok-big-title",
  "blok-subtitle": "TagBlok-module__cl093W__blok-subtitle",
  "blok-title": "TagBlok-module__cl093W__blok-title",
  "image-wrapper": "TagBlok-module__cl093W__image-wrapper",
  "tag-image": "TagBlok-module__cl093W__tag-image",
  "tag-link": "TagBlok-module__cl093W__tag-link",
});
